import { ReactNode, useState } from "react";

import { Typography } from "@ezmid/components-library";

type TabContent = {
  label: string;
  content: ReactNode;
};
type TabsData = Array<TabContent>;

type Props = {
  tabsData: TabsData;
};
export function Tabs({ tabsData }: Props) {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <div>
      <div className="flex space-x-3">
        {tabsData.map((tab, idx) => {
          return (
            <button
              key={tab.label}
              type="button"
              className={`border-b-4 transition-colors duration-300 ${
                idx === activeTabIndex
                  ? "border-spf-primary"
                  : "border-transparent hover:border-gray-200"
              }`}
              onClick={() => setActiveTabIndex(idx)}
            >
              <Typography className="text-gray-500" variant="body1">
                {tab.label}
              </Typography>
            </button>
          );
        })}
      </div>
      <div>{tabsData[activeTabIndex].content}</div>
    </div>
  );
}
